import { render, staticRenderFns } from "./UIFilesInput.vue?vue&type=template&id=c9ec5384&scoped=true&"
import script from "./UIFilesInput.vue?vue&type=script&lang=js&"
export * from "./UIFilesInput.vue?vue&type=script&lang=js&"
import style0 from "./UIFilesInput.vue?vue&type=style&index=0&id=c9ec5384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ec5384",
  null
  
)

export default component.exports